import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "vmr_wishlist_v1";
const WishlistCtx = createContext({ ids: [], toggle: () => {}, has: () => false, clear: () => {} });

function readLS() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === "number") : [];
  } catch (error) {
    console.warn("Wishlist: failed to read localStorage", error);
    return [];
  }
}

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(readLS);

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(ids));
    } catch (error) {
      console.warn("Wishlist: failed to save", error);
    }
  }, [ids]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setIds(readLS());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggle = useCallback((id) => {
    const num = Number(id);
    if (!num) return;
    setIds((prev) => (prev.includes(num) ? prev.filter((x) => x !== num) : [num, ...prev]));
  }, []);

  const has = useCallback((id) => ids.includes(Number(id)), [ids]);
  const clear = useCallback(() => setIds([]), []);

  const value = useMemo(() => ({ ids, toggle, has, clear }), [ids, toggle, has, clear]);

  return <WishlistCtx.Provider value={value}>{children}</WishlistCtx.Provider>;
}

export function useWishlist() {
  return useContext(WishlistCtx);
}
